'use client'

import type { NotificationType } from '@/types/notification'
import clsx from 'clsx'
import { useTranslations } from 'next-intl'
import { useId } from 'react'
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '../design-system/tabs'
import NotificationIcon from '../icons/notification'
import NotificationList from './notification-list'
import './notifications.scss'
import useNotificationsCount from './use-notifications-count'

export default function Notifications({
  fullScreen,
}: {
  fullScreen?: boolean
}) {
  const t = useTranslations('notifications')

  const count = useNotificationsCount()

  const tabs = [
    {
      value: 'activity',
      label: t('activity.trigger'),
      count: count.activity,
    },
    {
      value: 'alert',
      label: t('alert.trigger'),
      count: count.alert,
    },
  ]

  const titleId = useId()

  return (
    <div
      className={clsx(
        'notifications',
        fullScreen && 'notifications--full-screen'
      )}
    >
      <Tabs defaultValue={tabs[0].value} mountOnEnter>
        <div className='notifications__header'>
          <div className='notifications__title-wrapper'>
            <NotificationIcon color='primary' />

            <h2 className='notifications__title' id={titleId}>
              {t('title')}
            </h2>

            {count.total > 0 && (
              <span className='notifications__count'>{count.total}</span>
            )}
          </div>

          <TabList aria-labelledby={titleId}>
            {tabs.map((tab) => {
              return (
                <Tab key={tab.value} value={tab.value}>
                  {tab.label}
                  {tab.count > 0 && (
                    <span className='notifications__tab-count'>
                      {tab.count}
                    </span>
                  )}
                </Tab>
              )
            })}
          </TabList>
        </div>

        <div className='notifications__content'>
          <TabPanels>
            {tabs.map((tab) => (
              <TabPanel key={tab.value} value={tab.value}>
                <NotificationList type={tab.value as NotificationType} />
              </TabPanel>
            ))}
          </TabPanels>
        </div>
      </Tabs>
    </div>
  )
}
